import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Checkbox from './Checkbox';
import Highlighter from 'react-highlight-words';

export default class TreeSelector extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    selected: PropTypes.array,
    options: PropTypes.object,
    query: PropTypes.array,
    onChange: PropTypes.func,
  }

  static defaultProps = {
    selected: [],
    options: {},
    query: [],
    onChange() {},
  }

  constructor(props) {
    super(props);

    this.state = {
      options: this.props.options,
    };
  }
  handleExpandToggleClick = (item) => {
    item.expanded = !item.expanded;

    this.setState({ options: this.state.options });
  }

  renderOptions(options) {
    return Object.values(options).map((option) =>
      <li key={option.slug} className="u-flex u-flex-col">
        <div className="u-flex u-items-center TreeSelector-option">
          <span
            id={`expand-${option.slug}`}
            onClick={this.handleExpandToggleClick.bind(this, option)}
            className={`${Object.keys(option.children).length === 0 ? 'u-invisible' : 'u-flex u-cursor-pointer'}`}
          >
            { option.expanded ? <i className="Icon Icon-minus" /> : <i className="Icon Icon-plus" /> }
          </span>
          <Checkbox
            id={`checkbox-${option.slug}`}
            onChange={this.props.onChange.bind(this, this.props.id, option)}
            checked={this.props.selected.filter((selectedOption) => selectedOption === option.slug).length > 0}
            indeterminate={this.props.selected.filter((selectedOption) => {
              return Object.values(option.children).filter((childOption) => childOption.slug === selectedOption).length > 0;
            }).length > 0 && this.props.selected.filter((selectedOption) => selectedOption === option.slug).length === 0}
            wrapperClassName="checkbox--outline"
            className="u-my-0 u-p-0 u-mx-2" />
          <label className="u-mb-0 u-text-sm" htmlFor={`checkbox-${option.slug}`} id={`label-checkbox-${option.slug}`}>
            <Highlighter
              highlightClassName="u-font-bold u-bg-white"
              searchWords={this.props.query}
              textToHighlight={option.name}
            />
          </label>
        </div>
        { Object.keys(option.children).length > 0 && option.expanded &&
        <ul className="u-ml-6 u-mb-1">
          { this.renderOptions(Object.values(option.children)) }
        </ul>
        }
      </li>
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.options !== this.props.options) {
      this.setState({
        options: Object.values(this.props.options).reduce((acc, option) => {
          const expanded = this.state.options[option.id] !== undefined && this.state.options[option.id].expanded ? true : option.expanded;

          acc[option.id] = Object.assign({}, option, { expanded });
          return acc;
        }, {}),
      });
    }
  }

  render() {
    return (
      <ul className="TreeSelector">
        { this.renderOptions(this.state.options) }
      </ul>
    );
  }
}
